import { Flex, Loading } from '@100mslive/roomkit-react';

const FullPageProgress = () => (
    <Flex justify="center" align="center" css={{ width: '100vw', height: '100vh' }}>
        <Loading size={100} />
    </Flex>
);

export default FullPageProgress;
